import $ from 'jquery';

$(function () {
    const onOutsideClick = (e) => {
        if (!$(e.target).is('.sidebar-menu li')
            && $(e.target).closest('.sidebar-menu li').length === 0) {
            $('.sidebar-menu').removeClass('expanded');
        }
    };

    const open = (sidebar) => {
        sidebar.addClass('expanded');
        $(window).on('click', onOutsideClick);
    };

    const close = (sidebar) => {
        sidebar.removeClass('expanded');
        $(window).off('click', onOutsideClick);
    };

    $('.sidebar-menu').on('click', '.mobile-button-toggle, .active', (e) => {
        e.preventDefault();
        const menu = $(e.currentTarget).closest('.sidebar-menu');
        if (menu.hasClass('expanded')) {
            close(menu);
        } else {
            open(menu);
        }
    });
});
